import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import { getArtworkPurchaseGalleryProfile } from '@/pages/artwork/utils/artworkView.selectors';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import ThumbIcon from '@/shared-components/icons/components/artwork/ThumbIcon';
import Utils from '@/utils';

import './styles/ReviewsSummary.css';

export default function ReviewsSummary({ purchaseFetchData, artworkData, typeOfPurchase }) {
  const galleryProfile = getArtworkPurchaseGalleryProfile(artworkData);

  return (
    <>
      {
        typeOfPurchase === "limited_edition" ?
          <div className="reviews-summary__suarte">
            <LimitedEditionIcon className="reviews-summary__suarte-icon"/>

            <p className="reviews-summary__gallery-name dots-on-overflow font-size-medium">
                            Suarte
            </p>
          </div>
          :
          <div className="reviews-summary__suarte">
            <UserProfileImage
              typeOfProfile="gallery"
              image={galleryProfile.imageId}
              className="reviews-summary__gallery-image"
            />

            <p className="reviews-summary__gallery-name dots-on-overflow font-size-medium">
              {galleryProfile.name}
            </p>
          </div>
      }

      <div className="reviews-summary__content">
        <div className="reviews-summary__column">
          <span className="reviews-summary__column-text font-size-medium">
                        Positive
          </span>

          <ThumbIcon className="reviews-summary__column-icon positive"/>

          <span className="reviews-summary__column-text font-size-medium">
            {Utils.numberParserMillionThousand(purchaseFetchData.valorations.positive)}
          </span>
        </div>

        <div className="reviews-summary__column">
          <span className="reviews-summary__column-text font-size-medium">
                        Neutral
          </span>

          <ThumbIcon className="reviews-summary__column-icon neutral"/>

          <span className="reviews-summary__column-text font-size-medium">
            {Utils.numberParserMillionThousand(purchaseFetchData.valorations.neutral)}
          </span>
        </div>

        <div className="reviews-summary__column">
          <span className="reviews-summary__column-text font-size-medium">
                        Negative
          </span>

          <ThumbIcon className="reviews-summary__column-icon negative"/>

          <span className="reviews-summary__column-text font-size-medium">
            {Utils.numberParserMillionThousand(purchaseFetchData.valorations.negative)}
          </span>
        </div>
      </div>
    </>
  );
}
